export const version = {
  date: '2024-03-05T14:24:58.918Z',
  branch: 'development',
  revision: '0856550'
}